export default "__VITE_ASSET__DuCL2Pid__"